import { PartnerHierarchyType } from 'clickNgo/entities/partner/configs'

export const checkTopPartnerIdVisibility = (hierarchyType: PartnerHierarchyType) =>
  hierarchyType !== PartnerHierarchyType.HEADQUARTERS
